var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rating-block"},[_c('ul',{staticClass:"rating__list"},_vm._l((Math.round(_vm.rating)),function(index){return _c('li',{key:index,staticClass:"rating__item"},[_c('RatingStarIcon')],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }